module.exports = __webpack_public_path__ + "img/agri_image.3e559305.png";